export default "__VITE_ASSET__tKZT4Trz__"